<q9-blur-wrapper
  [class.hide-page-loader]="permissionService.isFree()"
  [class.full-height]="true"
  [blur]="permissionService.isFree()"
  [title]="blurTitle"
  [text]="blurText">
  <q9-grid
    [columns]="columns"
    [selectBy]="'_id'"
    [enableMultiSelect]="isMultipleMode"
    [menuItems]="menuItems"
    [displayHorizontalContextMenu]="true"
    [noRecordsMessage]="'RUBIC_CUBE.NO_RECORDS'"></q9-grid>
</q9-blur-wrapper>

<ng-container *ngIf="!permissionService.isFree() && (selectedNode$ | async) as node">
  <q9-org-node-sidebar
    [disableClose]="false"
    [orgInfo]="orgInfo$ | async"
    [node]="node"
    [opened]="showSidebar$ | async"
    [refModel]="refModelData$ | async"></q9-org-node-sidebar>
</ng-container>
